import React from 'react';
import RoundedButton, { ButtonProps } from './RoundedButton';

export interface GreyableButtonProps extends ButtonProps {
  clickable?: boolean;
}

const GreyableButton = ({ onClick, clickable = true, className, ...rest }: GreyableButtonProps) => {
  return (
    <RoundedButton
      onClick={clickable ? onClick : undefined}
      className={(clickable ? '' : 'opacity-60 cursor-not-allowed ') + className}
      {...rest}
    ></RoundedButton>
  );
};

export default GreyableButton;
